export default function AdGenerater(props) {
  const areaCheck = props.id;
  let srcUrl;

  if (areaCheck === 'top') {
    srcUrl = '/html/m/top.htm';
  } else if (areaCheck === 'middle') {
    srcUrl = '/html/m/middle.htm';
  } else if (areaCheck === 'live') {
    srcUrl = '/html/m/live.htm';
  } else {
    srcUrl = '/html/m/bottom.htm';
  }

  // * 2023 항저우아시안게임
  if (areaCheck === 'live_top_ag_2023') {
    return (
      <div className='bigEventBanner_w'>
        <div className='bigEventBannerTop_w'>
          <iframe title='배너광고' className="bigEventBanner_img" display='block' src='/html/m/live_top_ag_2023.htm' width='300px' height='100px' scrolling='no' frameBorder='0' marginWidth='0' marginHeight='0' align='middle' />
        </div>
      </div>
    );
  } 

  return (
    <div className={(areaCheck === 'live') ? 'contents_area_ad' : 'main_contents_ad'}>
      <div className='ad_banner_w'>
        <iframe title='배너광고' display='block' src={srcUrl} width='300px' height='100px' scrolling='no' frameBorder='0' marginWidth='0' marginHeight='0' align='middle' />
      </div>
    </div>
  );
}
